import { TCompilationType } from '../../../types/promosPage';

const ORANGE_TO_BLUE_GRADIENT = 'linear-gradient(135deg, #ffdcc8 0%, #c1e8fd 100%)';
const BLUE_TO_PINK_GRADIENT = 'linear-gradient(75deg, #c1e8fd 0%, #ffe1ff 97.18%)';

export const getPromoCompilationBackground = (type: TCompilationType): string => {
  switch (type) {
    case 'topPromos':
      return ORANGE_TO_BLUE_GRADIENT;
    case 'lastChanceDiscount':
      return BLUE_TO_PINK_GRADIENT;
    default:
      return BLUE_TO_PINK_GRADIENT;
  }
};
